// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2zyNA","disabled":"FileBtn_disabled__1pgO1","warn":"FileBtn_warn__2W4-K","fade":"FileBtn_fade__3SXlT"};